import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { StandardDivProps } from '@sprinx/react-mui-components/StandardDiv';
import withThemeProps from '@sprinx/react-mui-components/withThemeProps';
import clsx from 'clsx';
import React from 'react';
import { ProductDetailProduct } from '../../../api/products/productDetail';
import ProductStockQuantityInfo from '../../../components/ProductStockQuantityInfo';

export interface ProductDetailStockInfoProps extends StandardDivProps<ProductDetailStockInfoClassKey> {
  product: ProductDetailProduct;
}

export type ProductDetailStockInfoClassKey = 'root';

const themeSettings = { name: 'ProductDetailStockInfo' };
const useStyles = makeStyles(
  (theme: Theme) =>
    createStyles<ProductDetailStockInfoClassKey, {}>({
      root: {
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'flex-start',
        paddingBottom: theme.spacing(1),
      },
    }),
  themeSettings,
);

const ProductDetailStockInfo = React.forwardRef<HTMLDivElement, ProductDetailStockInfoProps>(
  ({ className, classes: pClasses, product }, ref) => {
    const classes = useStyles({ classes: pClasses });

    return (
      <div ref={ref} className={clsx(classes.root, className)}>
        <ProductStockQuantityInfo size='large' product={product} />
      </div>
    );
  },
);

ProductDetailStockInfo.displayName = 'ProductDetailStockInfo';

export default withThemeProps(themeSettings)(ProductDetailStockInfo);
